export const stopPropagation = (evt) => evt.stopPropagation();
export const preventDefault = (evt) => evt.preventDefault();
export const sortablePreventDOMManipulation = (evt) => {
    evt.item.remove();
    if (evt.oldIndex !== undefined) {
      evt.from.insertBefore(
        evt.item,
        // For some reason, this offset is needed in the soundboards
        evt.from.childNodes[(evt.oldIndex + 1) * 2 - 1],
      );
    }
}
// Because the Library uses pull: `clone`, we just have to remove the uncloned element.
export const sortablePreventDOMManipulationInLibrary = (evt) => {
    evt.from.childNodes[evt.oldIndex].remove()
    evt.from.insertBefore(
      evt.item,
      evt.from.childNodes[evt.oldIndex]
    )
}
export const sortablePreventUnmovableItemsFromMoving = (evt) => {
    if(evt.related.classList.contains('unmovable')) {
        return false;
    }
}
export const sortableForceFallbackForFirefox = () => {
  return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
}